import { render, staticRenderFns } from "./ErrorMessageDialog.vue?vue&type=template&id=45b299b7&"
import script from "./ErrorMessageDialog.vue?vue&type=script&lang=js&"
export * from "./ErrorMessageDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/__w/ddv-home/ddv-home/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('45b299b7')) {
      api.createRecord('45b299b7', component.options)
    } else {
      api.reload('45b299b7', component.options)
    }
    module.hot.accept("./ErrorMessageDialog.vue?vue&type=template&id=45b299b7&", function () {
      api.rerender('45b299b7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ErrorMessageDialog.vue"
export default component.exports